import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable, signal } from '@angular/core';
import { SERVICE_SETTINGS_SOCIAL_WORK_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsSocialWorkType,
} from '../../../../../modules/content/pages/services/settings/service-settings-social-work/service-settings-social-work.types';
import { SocialServiceProcedureTypeEnum } from '@libs/types/src/services/enum/social-service-intervention-type.enum';
import { translate } from '../../../../../modules/shared/shared.global-service';
import { SocialServicePresenceTypeEnum } from '@libs/types/src/services/enum/social-service-presence-type.enum';

@Injectable()
export class SocialServiceOfferDetailDialogStore extends ComponentStoreV2Factory {

    public serviceId = signal(0);

    public workSettings = computed<ServiceSettingsSocialWorkType>(() => this.globalGlobalStore.organizationStore.getServiceSetting<ServiceSettingsSocialWorkType>(this.serviceId(), SERVICE_SETTINGS_SOCIAL_WORK_KEY));

    public typeOptions = computed(() => {
        const data = this.workSettings();
        let options = [
            {
                name: translate.instant(`service.settings.socialWorks.procedureType.${SocialServiceProcedureTypeEnum.PROCEDURE}`),
                value: SocialServiceProcedureTypeEnum.PROCEDURE,
            },
        ];

        const useIntervention = data?.useIntervention;
        if (!useIntervention) return options;

        const interventions: any[] = [
            {
                name: translate.instant(`service.settings.socialWorks.procedureType.${SocialServiceProcedureTypeEnum.INTERVENTION}`),
                value: SocialServiceProcedureTypeEnum.INTERVENTION,
            },
        ];
        data?.interventionTypes?.forEach((it) => {
            interventions.push({
                name: translate.instant(`service.settings.socialWorks.interventions.${it}`),
                value: it,
            });
        });

        if (data?.interventionAsDefault) {
            options = [...interventions, ...options];
        } else {
            options.push(...interventions);
        }

        return options;
    });

    public presenceOptions = computed(() => {
        const setting = this.workSettings();
        const options: any[] = [
            {
                name: translate.instant(`service.settings.socialWorks.presence.${SocialServicePresenceTypeEnum.PRESENT}`),
                value: SocialServicePresenceTypeEnum.PRESENT,
            },
            {
                name: translate.instant(`service.settings.socialWorks.presence.${SocialServicePresenceTypeEnum.NON_PRESENT}`),
                value: SocialServicePresenceTypeEnum.NON_PRESENT,
            },
        ];

        const translatePrefix = translate.instant(`service.settings.socialWorks.presence.${SocialServicePresenceTypeEnum.MEDIATED}`);
        setting.mediatedForms?.forEach((it) => {
            const value = `${SocialServicePresenceTypeEnum.MEDIATED}_${it}`;
            const translatedName = translate.instant(`service.settings.socialWorks.mediatedForm.${it}`);

            options.push({
                name: `${translatePrefix}: ${translatedName}`,
                value,
            });
        });

        return options;
    });

}
